<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormDescarteCliente" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="IdTipoDescarte">Tipo Descarte</label>
							<select v-model="objDescarteCliente.IdTipoDescarte" class="form-control form-select" id="IdTipoDescarte">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item,index) in ListaTipoDeDescartes" :key="index" :value="item.IdTipoDescarte">
									{{item.Nombre}}
								</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdTipoDescarte" :Mensaje="'*'+errorvalidacion.IdTipoDescarte[0]"/>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="MotivoDescarte">Motivo Descarte</label>
							<textarea v-model="objDescarteCliente.MotivoDescarte" class="form-control" id="MotivoDescarte" placeholder="Ingresar MotivoDescarte" rows="5"></textarea>
							<CValidation v-if="this.errorvalidacion.MotivoDescarte" :Mensaje="'*'+errorvalidacion.MotivoDescarte[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
							<label class="form-label" for="FechaDescarte">Fecha Descarte</label>
							<div class="calendar">
								<input type="text" v-model="objDescarteCliente.FechaDescarte" class="form-control" id="FechaDescarte" placeholder="Ingresar FechaDescarte" readonly />
							</div>
							<CValidation v-if="this.errorvalidacion.FechaDescarte" :Mensaje="'*'+errorvalidacion.FechaDescarte[0]"/>
						</div>
					</div>
								
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import moment from 'moment';

export default {
    name: 'FormDescarteCliente',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objDescarteCliente: {
				IdDescarteCliente: 0,
				IdTipoDescarte: 0,
				MotivoDescarte: '',
				FechaDescarte: '',
				IdCliente: 0,
				IdUsuario: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			ListaTipoDeDescartes: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objDescarteCliente.IdDescarteCliente == 0) {
				await this.$http.post(
					'descarteClientes',this.objDescarteCliente
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'descarteClientes/'+this.objDescarteCliente.IdDescarteCliente,
					this.objDescarteCliente
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionCliente');
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "descarteClientes/"+this.objDescarteCliente.IdDescarteCliente
            ).then((res) => {
                this.objDescarteCliente = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objDescarteCliente.Fecha.replace(/-/g,'\/');
                this.objDescarteCliente.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objDescarteCliente = {
				IdDescarteCliente: 0,
				IdTipoDescarte: 0,
				MotivoDescarte: '',
				FechaDescarte: '',
				IdCliente: 0,
				IdUsuario: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				
            }
            this.errorvalidacion = [];
        },
		GetListTipoDescarte()
		{
			this.$http.get("tipoDescartes",{
                params:{
                    simple: 1,
                }
            }).then((res) => {
                this.ListaTipoDeDescartes = res.data.data;

            }).finally(()=>{
            });
		},
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
			this.GetListTipoDescarte();

			this.objDescarteCliente.FechaDescarte = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
			this.objDescarteCliente.IdCliente = obj.IdCliente;
                
            /* if (Id!='') 
            {
                this.objDescarteCliente.IdDescarteCliente = Id;
                this.Recuperar();
            }
            else
            { */
                this.ConfigLoad.ShowLoader = false;
            //}
        });
    }
}
</script>
